import React from 'react'
import {Link} from 'gatsby'
import LazyLoad from 'react-lazyload'

// Components
import RPs from './RecentProperties.styled'

// Utils
import {enhancedGet, convertMoney, combineAddress} from '~/utils'

const RecentPropertiesComponent = (props) => {
  const {
    list,
  } = props

  return (
    <RPs>
      <RPs.Title>BĐS mới nhất</RPs.Title>

      <RPs.ItemsWrapper>
        {list.map((item) => {
          const {
            id,
            name,
            slug,
            thumbnail,
            addressNumber,
            street,
            price,
          } = item

          const streetName = enhancedGet(street, 'name')

          const address = combineAddress({
            addressNumber,
            street: streetName,
          })
          // const address = addressNumber + (streetName ? ` ${streetName}` : '')

          return (
            <RPs.Item key={id} as={Link} to={`/${slug}`}>
              <RPs.ItemThumbnail>
                <LazyLoad
                  className='img-container'
                  once
                  offset={250}
                >
                  <img
                    alt={thumbnail.alt || name}
                    src={thumbnail.url}
                    srcSet={thumbnail.srcSet}
                    sizes={thumbnail.sizes}
                    className='img-cover-center'
                    style={{height: '100%'}}
                  />
                </LazyLoad>

                <noscript>
                  <div className='img-container'>
                    <img
                      alt={thumbnail.alt || name}
                      src={thumbnail.url}
                      srcSet={thumbnail.srcSet}
                      sizes={thumbnail.sizes}
                      className='img-cover-center'
                      style={{height: '100%'}}
                    />
                  </div>
                </noscript>
              </RPs.ItemThumbnail>

              <RPs.ItemRight>
                <RPs.ItemTitle>{name}</RPs.ItemTitle>

                <RPs.ItemAddress {...{address}} />

                <RPs.ItemPrice>{convertMoney(price)}</RPs.ItemPrice>
              </RPs.ItemRight>
            </RPs.Item>
          )
        })}
      </RPs.ItemsWrapper>
    </RPs>
  )
}

export default RecentPropertiesComponent
